// extracted by mini-css-extract-plugin
export default {"transparentBackground":"styles_transparentBackground__4m7XJ"};